const FieldTypeUtils = require('./fieldTypes');

const GROUPABLE_LAYOUT_TYPES = new Set([
    'emoji'
]);

exports.flattenFields = (fields = []) => {

    return fields.reduce((collector, field) => {

        if (!field) {
            return collector;
        }

        if (Array.isArray(field)) {
            collector.push(...exports.flattenFields(field));
            return collector;
        }

        collector.push(field);
        return collector;
    }, []);
};

exports.getFieldChildren = (field = {}) => {

    if (Array.isArray(field.fields)) {
        return field.fields;
    }

    return [];
};

exports.flattenFieldDefinitions = (fields = []) => {

    return fields.reduce((collector, field) => {

        if (!field) {
            return collector;
        }

        if (Array.isArray(field)) {
            collector.push(...exports.flattenFieldDefinitions(field));
            return collector;
        }

        collector.push(field);

        const children = exports.getFieldChildren(field);

        if (children.length) {
            collector.push(...exports.flattenFieldDefinitions(children));
        }

        return collector;
    }, []);
};

exports.getFallbackFieldDefinition = (fieldName) => ({
    name: fieldName,
    label: fieldName,
    type: 'TextField'
});

exports.getFieldDefinition = ({
    fieldName,
    fields
}) => exports.flattenFieldDefinitions(fields).find((field) => field.name === fieldName)
    || exports.getFallbackFieldDefinition(fieldName);

exports.normalizeFields = (fields = []) => {

    return exports.flattenFields(fields).filter((field) => !!field);
};

exports.normalizeFieldItems = (fieldOrItems = []) => {

    const items = Array.isArray(fieldOrItems)
        ? fieldOrItems
        : exports.getFieldChildren(fieldOrItems);

    return exports.normalizeFields(items);
};

exports.getFieldKey = ({
    field = {},
    fallback
}) => {

    return field.key || field.name || field.text || fallback;
};

exports.getNormalizedFieldType = (field = {}) => FieldTypeUtils.normalizePrimitiveType(field.type);

exports.isFullWidthField = (field = {}) => {

    return !!field.fullWidth
        || field.name === 'interests'
        || exports.getNormalizedFieldType(field) === 'TextareaField';
};

exports.isBreakField = (field = {}) => {

    return field.type === 'break';
};

exports.isGroupableField = (field = {}) => (
    (GROUPABLE_LAYOUT_TYPES.has(field.type) || FieldTypeUtils.isGroupablePrimitiveType(field.type))
    && !exports.isFullWidthField(field)
);

exports.buildSegments = (fields = []) => {

    const segments = [];
    let buffer = [];
    const flushBuffer = () => {

        if (!buffer.length) {
            return;
        }

        segments.push({
            type: 'group',
            fields: buffer
        });
        buffer = [];
    };

    exports.normalizeFields(fields).forEach((field) => {

        if (exports.isBreakField(field)) {
            flushBuffer();
            return;
        }

        if (exports.isGroupableField(field)) {
            buffer.push(field);
            return;
        }

        flushBuffer();
        segments.push({
            type: 'single',
            field
        });
    });

    flushBuffer();
    return segments;
};

exports.GROUPABLE_FIELD_TYPES = [
    ...Array.from(FieldTypeUtils.GROUPABLE_PRIMITIVE_TYPES),
    ...Array.from(GROUPABLE_LAYOUT_TYPES)
];
